<!-- 设备管理-生产列表-查看日志 -->
<template>
  <!-- 模板一，不改变面包屑 -->
  <div class="mainArea ViewLog">
    <!-- 主要头部内容 -->
    <div class="mainHeadContent">
      <!-- 面包屑 -->
      <BreadCrumb></BreadCrumb>
    </div>
    <!--主内容区-->
    <div class="mainBodyContent">

      <!-- 搜索框 -->
      <div class="searchBox clearfix">
        <el-input class="searchInput" v-model="stockLogData.paging.device_no_id" placeholder="请输入设备ID" clearable></el-input>
        <el-button class="searchBtn" type="primary" @click="getStockLogList('search')">搜 索</el-button>
        <el-button class="back" @click="back">返 回</el-button>
      </div>

      <!-- 日志列表 -->
      <el-table
        :data="stockLogData.list"
        style="width: 100%">
        <el-table-column
          type="index"
          label="序号">
        </el-table-column>
        <el-table-column
          property="device_no_id"
          label="设备ID">
        </el-table-column>
        <el-table-column
          property="user_name"
          label="操作人">
        </el-table-column>
        <el-table-column
          property="log"
          label="操作内容">
        </el-table-column>
        <el-table-column
          property="create_time"
          label="操作时间">
        </el-table-column>
      </el-table>
      
      <!-- 分页 -->
      <div class="paging" v-if="stockLogData.pageCount > 1">
        <el-pagination
          @size-change="sizeChange"
          @current-change="pageChange"
          :current-page.sync="stockLogData.paging.page"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[20, 50, 100, 500]"
          :page-count="stockLogData.pageCount"
          :page-size.sync="stockLogData.paging.perPage"
          >
        </el-pagination>
      </div>

    </div>
  </div>
</template>

<script>
  import BreadCrumb from "../../../Layout/BreadCrumb.vue"
  import { deviceApi } from "../../../../../static/js/api.js"
  import { showToast } from '../../../../../static/js/utility/utility';

  export default {
    name: 'ViewLog',
    components: {
      BreadCrumb
    },
    data() {
      return {
        // 日志相关数据
        stockLogData: {
          list: [],
          paging: {
            page: 1,
            perPage: 10,
            device_no_id: ''
          }
        }
      }
    },
    mounted(){
      this.getStockLogList()
    },
    created: async function () {
    },
    methods: {
      // 获取日志列表
      getStockLogList: async function (search) {
        let vm = this
        let data = vm.stockLogData.paging
        if (search) {
          data.page = 1
          if (data.device_no_id === '') {
            showToast('请输入要查询的设备ID！')
            return
          }
        }

        let res = await deviceApi.getStockLogList(data)
        if (res.meta.code === 200) {
          vm.stockLogData.list = res.data.list
          vm.stockLogData.pageCount = res.data.pageCount
        } else {
          showToast(res.meta.message)
        }
      },

      // 每页显示数量变化，获取新的协议列表
      sizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.getStockLogList()
      },

      // 翻页 --- 当前页值改变，获取新的日志列表
      pageChange(val) {
        console.log(`当前页: ${val}`);
        this.getStockLogList()
      },
      // 返回上一页
      back: function () {
        this.$router.go(-1)
      }
    },
    watch: {
      // 监听查询id的变化，清空获取新的日志列表
      'stockLogData.paging.device_no_id': function (newVal) {
        // console.log('已出库查询id', newVal)
        if (newVal === '') {
          this.getStockLogList()
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.ViewLog {
  .searchBox {
    width: 100%;
    height: 40px;
    margin-bottom: 20px;
    .searchInput {
      float: left;
      width: 300px;
      margin-right: 20px;
    }
    .searchBtn {
      float: left;
    }
    .back {
      float: right;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/DeviceManage/ProductList/ViewLog.vue